<template>
  <section class="layout-pt-md layout-pb-md" :style="`background-color: var(--c-${vars.backgroundColor});`">
    <div class="marquee js-marquee">
      <div class="js-first" style="font-family: var(--f-primary); font-weight: 600 !important">
        {{ vars.firstText }}
      </div>
      <div class="js-second text-accent-1" style="font-family: var(--f-primary); font-weight: 600 !important">
        {{ vars.secondText }}
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Mobilde h5 boyutuna indiriyoruz */
@media (max-width: 640px) {
  .js-first,
  .js-second {
    font-size: 3.25rem !important; /* h5 ≈ 1.25rem */
    line-height: 3.5rem !important;
  }
}
</style>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'Theme7ScrollAnimationTexts',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },
});
</script>
